import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
import {IReport} from "@/modules/Report/interfaces/report.interface";
import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";

export namespace IBook {
  export const ACTION = 'books_get';

  export interface CatalogData<T = number> {
    id: T;
    name: string;

    hideFlag?: number;
  }

  export enum TableName {
    Corps = 'corps',
    Tarifs = 'tarifs',
    CarStatuses = 'CarStatuses',
    BalanceTypes = 'balanceTypes',
    newOffer = 'newOffer',
    parks = 'parks',
    globalParks = 'globalParks',
    parksMyAll = 'parksMyAll',
    carsHistory = 'carsHistory',
    claimTypes = 'claimTypes',
    parksOwners = 'parksOwners',
    carBalanceTypes = 'carBalanceTypes',
    carsMyCorpForFavorite = 'carsMyCorpForFavorite',
    demoCars = 'demoCars',
    carTypes = 'carTypes',
    groupTypes = 'groupTypes',
    fltStrSearch = 'fltStrSearch',
    cameras = 'cameras',
    visitPurposeTypes = 'visitPurposeTypes',
    scenarioTypes = 'scenarioTypes',
    corpsParents = 'corpsParents',
    dashboardTSumTypes = 'dashboardTSumTypes',
  }

  export enum BookName {
    Corps = 'corps',
    tarifs = 'tarifs',
    CarStatuses = 'carStatuses',
    balanceTypes = 'balanceTypes',
    newOffer = 'newOffer',
    parks = 'parks',
    globalParks = 'globalParks',
    parksMyAll = 'parksMyAll',
    carsHistory = 'carsHistory',
    claimTypes = 'claimTypes',
    parksOwners = 'parksOwners',
    carBalanceTypes = 'carBalanceTypes',
    carsMyCorpForFavorite = 'carsMyCorpForFavorite',
    demoCars = 'demoCars',
    carTypes = 'carTypes',
    groupTypes = 'groupTypes',
    cameras = 'cameras',
    visitPurposeTypes = 'visitPurposeTypes',
    scenarioTypes = 'scenarioTypes',
    corpsParents = 'corpsParents',
    dashboardTSumTypes = 'dashboardTSumTypes',
  }

  export interface IState {
    loading: boolean;
    books: {
      [BookName.Corps]: CorpBookItem[];
      [BookName.tarifs]: CatalogData[];
      [BookName.CarStatuses]: CatalogData[];
      [BookName.balanceTypes]: CatalogData[];
      [BookName.parks]: ParkBookItem[];
      [BookName.globalParks]: ParkBookItem[];
      [BookName.parksMyAll]: ParkBookItem[];
      [BookName.claimTypes]: CatalogData[];
      [BookName.parksOwners]: CatalogData[];
      [BookName.carBalanceTypes]: CatalogData[];
      [BookName.carsMyCorpForFavorite]: CatalogData[];
      [BookName.demoCars]: Barrier.IDemoCarsBook[];
      [BookName.carTypes]: CatalogData[];
      [BookName.groupTypes]: CatalogData[];
      [BookName.cameras]: CamerasBookItem[];
      [BookName.visitPurposeTypes]: CatalogData[];
      [BookName.scenarioTypes]: ScenarioBookItem[];
      [BookName.corpsParents]: CatalogData[];
      [BookName.dashboardTSumTypes]: CatalogData[];
    };
  }

  export interface GetBookParams {
    tableName?: BookName;
    bookNames?: BookName[];
    needUpdate?: boolean;
    // There may be other parameters required for a personal book.
    reportName?: IReport.ReportName; // Only for report pages.
  }

  export interface ParkBookItem extends CatalogData {
    phoneSecurity?: string;
    rptMovsTypeId?: IMovementsReport.TableConfigType;
    payByCarNumberFlag?: boolean;
  }

  export interface CorpBookItem extends CatalogData {
    dftParkId?: number;
    trailerRequestFlag?: boolean;
  }

  export interface ScenarioBookItem extends CatalogData {
    description?: string;
  }

  export interface CamerasBookItem extends CatalogData {
    globalParkId?: number;
    parkId?: number;
    typeId?: number;
  }
}
